import { TrendingUp, TrendingDown, Minus, Activity } from 'lucide-react';
import type { CreditScoreStats } from '../../services/api/endpoints/creditScore';
import type { AuditorCompany } from '../../types/auditor';
import { getScoreBadgeBg } from '../../utils/creditScoreHelpers';

interface CreditScoreBadgeProps {
  creditScore?: CreditScoreStats | null;
  /** When provided, renders a CET button next to the badge */
  company?: AuditorCompany;
  onCetClick?: (company: AuditorCompany) => void;
  /** compact = row style (smaller), default = card style */
  compact?: boolean;
}

export function CreditScoreBadge({
  creditScore,
  company,
  onCetClick,
  compact = false,
}: CreditScoreBadgeProps) {
  const badgePx = compact ? 'px-1.5 py-0.5' : 'px-2 py-0.5';
  const badgeRadius = compact ? 'rounded' : 'rounded-md';

  return (
    <div className="flex items-center gap-2">
      {creditScore ? (
        <span
          className={`inline-flex items-center gap-1 ${badgePx} ${badgeRadius} text-xs font-bold tabular-nums ${getScoreBadgeBg(creditScore.currentScore)}`}
        >
          {creditScore.currentScore}
          {!compact && <span className="font-normal">/100</span>}
          {creditScore.trend === 'up' && <TrendingUp className="h-3 w-3" />}
          {creditScore.trend === 'down' && <TrendingDown className="h-3 w-3" />}
          {creditScore.trend === 'stable' && <Minus className="h-3 w-3" />}
        </span>
      ) : (
        <span className="text-xs text-muted-foreground">{compact ? '—' : 'Score: —'}</span>
      )}
      {company && onCetClick && (
        <button
          onClick={(e) => { e.stopPropagation(); onCetClick(company); }}
          className={`inline-flex items-center gap-1 ${badgePx} ${badgeRadius} text-xs font-medium
            bg-indigo-50 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-400
            hover:bg-indigo-100 dark:hover:bg-indigo-900/50 transition-colors`}
          title="Contexte Économique Territorial"
        >
          <Activity className="h-3 w-3" />
          CET
        </button>
      )}
    </div>
  );
}
